<template>
    <ModalComponent
        :name="'eventos-cesion-modal'"
        :title="$t('perfil_sga.titulo_cesion')"
        @close="$emit('close')"
        size="lg"
        @opened="getEventosCesion()"
    >
        <template v-if="!showBenefits">
            <div v-if="loading || loadingCesiones" class="text-center py-4">
                <div class="spinner-border" role="status">
                </div>
                <p class="mt-2">{{$t('perfil_sga.cargando')}}</p>
            </div>
            
            <div v-else-if="eventosCesion.length === 0" class="text-center py-4">
                <b-icon icon="calendar-x" style="font-size: 3rem;" class="text-muted mb-3"/>
                <p class="text-muted">{{$t('perfil_sga.no_eventos_cesion')}}</p>
            </div>
            
            <div v-else>
                <div class="row">
                    <b-col cols="12">
                        <b-button block class="mb-3" variant="outline-primary" @click="showBenefits = true">
                            Mostrar mis beneficios
                        </b-button>
                    </b-col>
                    <div class="col-12 mb-3" v-for="evento in eventosCesion" :key="evento.id">
                        <b-card class="border shadow-sm">
                            <b-card-body class="p-3">
                                <div class="w-100 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                    <div class="d-flex align-items-center p-2 mb-2 mb-md-0">
                                        <div class="border d-flex align-items-center justify-content-center  mr-3 rounded-circle overflow-hidden" style="width: 30px; height: 30px;">
                                            <b-icon icon="calendar-event" class="text-primary" style="width: 15px; height: 15px;"/>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ evento.name  }}</p>
                                    </div>
                                    
                                    <div class="d-flex align-items-center font-weight-normal">
                                        <b-icon icon="calendar"  />
                                        <p class="mb-0 px-3">{{ evento.start_event_date }}</p>
                                    </div>
                                    <div class="p-2">
                                        <button v-if="checkCond(evento.status,'Active')" class="btn btn-primary" @click="cederEvento(evento)">
                                            {{ $t('perfil_sga.ceder') }}
                                        </button>
                                        <button v-else-if="checkCond(evento.status,'Ceded')" class="btn btn-primary" @click="recuperarEvento(evento)">
                                            {{ $t('perfil_sga.recuperar') }}
                                        </button>
                                        <button v-else-if="checkCond(evento.status,'Ceding') || checkCond(evento.status,'Recovering')" class="btn btn-info" style="cursor: default;" disabled>
                                            {{ $t('perfil_sga.en_proceso') }}
                                        </button>
                                        <div v-else class="btn-danger p-2 rounded" style="cursor: not-allowed;">
                                            {{ $t('perfil_sga.no_disponible') }}
                                        </div>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <b-row>
                <b-col cols="12">
                    <b-button block variant="outline-primary" class="mb-3" @click="showBenefits = false">
                        Volver al listado de cesiones
                    </b-button>
                </b-col>
                <b-col cols="12">
                    <b-table
                        striped
                        hover
                        :items="benefits.data"
                        :fields="[
                            {
                                key: 'eventName',
                                label: 'Evento',
                                sortable: false
                            },
                            {
                                key: 'benefitPercentage',
                                label: 'Porcentaje de beneficio',
                                sortable: false
                            },
                            {
                                key: 'benefitValue',
                                label: 'Valor',
                                sortable: false
                            }
                        ]"
                        v-if="!loading"
                    >
                        <template #cell(benefitPercentage)="data">
                            {{ data.value }}%
                        </template>
                        <template #cell(benefitValue)="data">
                            {{ data.value | formatear_precio }}
                        </template>
                    </b-table>
                    <div v-if="loading" class="text-center py-4">
                        <div class="spinner-border" role="status">
                        </div>
                        <p class="mt-2">Cargando beneficios.</p>
                    </div>
                </b-col>
            </b-row>
        </template>        
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        name: "CesionesModal",
        props: {
            abonadoId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                loading: false,
                loadingCesiones: false,
                eventosCesion: [],
                benefits: null,
                showBenefits: false
            }
        },
        watch: {
            showBenefits(newVal) {
                if (newVal && !this.benefits) {
                    this.getBeneficios();
                }
            }
        },
        methods: {
            getEventosCesion() {
                this.loading = true;
                this.eventosCesion = [];

                const params = {
                    abonado_id: this.abonadoId
                };
    
                this.$store.dispatch(this.config.getVuexAlias("sga.profile.eventos-cesion"), params).then(res => {
                    this.eventosCesion = res.data.data;
                }).catch(error => {
                    this.$toast.error(this.$t('perfil_sga.error_carga_eventos'));
                    this.eventosCesion = [];
                }).finally(() => {
                    this.loading = false;
                    this.updateEvents = true;
                });
            },
            getBeneficios() {
                this.loading = true;

                const params = {
                    abonado_id: this.abonadoId
                };
    
                this.$store.dispatch(this.config.getVuexAlias("sga.profile.abono.cesion.benefits"), params).then(res => {
                    this.benefits = res.data;
                }).catch(error => {
                    this.$toast.error('Error al recuperar los beneficios de cesión');
                    this.benefits = null;
                }).finally(() => {
                    this.loading = false;
                });
            },
            checkCond(value1, value2) {
                if ((value1 === "Ceding" || value1 === "Recovering") && this.updateEvents) {
                    this.updateEvents = false;
                    setTimeout(() => {
                        this.getEventosCesion(this.abonadoCesion);
                    }, 3000);
                }
                return value1 === value2;
            },
            cederEvento(evento) {
                this.loadingCesiones = true;

                const params = {
                    ticketEntitlementId: evento.entrada_entitlement_sga_id
                };
    
                this.$store.dispatch(this.config.getVuexAlias("sga.evento.ceder"), params).then(res => {
                    this.$toast.success(this.$t('perfil_sga.evento_cedido_correctamente'));
                    this.getEventosCesion(this.abonadoCesion);
                }).catch(error => {
                    console.error(error);
                    this.$toast.error(this.$t('perfil_sga.error_ceder_evento'));
                }).finally(() => {
                    this.loadingCesiones = false;
                });
            },
            recuperarEvento(evento) {
                this.loadingCesiones = true;
                const params = {
                    ticketEntitlementId: evento.entrada_entitlement_sga_id
                };

                this.$store.dispatch(this.config.getVuexAlias("sga.evento.recuperar"), params).then(res => {
                    this.$toast.success(this.$t('perfil_sga.evento_recuperado_correctamente'));
                    this.getEventosCesion(this.abonadoCesion);
                }).catch(error => {
                    console.error(error);
                    this.$toast.error(this.$t('perfil_sga.error_recuperar_evento'));
                }).finally(() => {
                    this.loadingCesiones = false;
                });
            },
        },
        components: {
            ModalComponent
        }
    }
</script>